export default __webpack_public_path__ + "static/media/r3.6eb8d318.jpg";